import React, { createContext, useContext, useState, useEffect } from 'react';

const THEME_STORAGE_KEY = 'rudvan-theme';

const ThemeContext = createContext();

// Same key CurriculumMenuPage.jsx already wrote to before this context
// existed, so an existing stored preference carries over instead of
// resetting. Defaults to light for a first-time visitor with nothing
// stored (docs/DECISIONS.md - the rebranded app's light-first look).
function getInitialTheme() {
  return window.localStorage.getItem(THEME_STORAGE_KEY) === 'dark';
}

// Single shared dark/light theme state (docs/DECISIONS.md, "Persistent
// left-side student navigation + light-theme visual fix") - previously
// Home.jsx, CurriculumMenuPage.jsx, and Login.jsx each held their own
// separate, unsynced isDarkTheme useState, so toggling theme in one place
// didn't affect the others and Home.jsx/Login.jsx didn't persist at all.
export function ThemeProvider({ children }) {
  const [isDarkTheme, setIsDarkTheme] = useState(getInitialTheme);

  useEffect(() => {
    window.localStorage.setItem(THEME_STORAGE_KEY, isDarkTheme ? 'dark' : 'light');
  }, [isDarkTheme]);

  const toggleTheme = () => setIsDarkTheme((prev) => !prev);

  return (
    <ThemeContext.Provider value={{ isDarkTheme, setIsDarkTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useThemeMode() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeMode must be used within ThemeProvider');
  }
  return context;
}
